<mat-accordion>
    <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <h2><mat-icon>home</mat-icon> {{language.Verwaltung | translationPipe}}</h2>
            </mat-panel-title>
        </mat-expansion-panel-header>

        @if(appService.isUserAdmin()){
        <dba-settings-item icon="person" routerLink="/userMain">
            {{language.Benutzer | translationPipe}}
        </dba-settings-item>
        <dba-settings-item icon="groups" routerLink="/groupMain">
            {{language.Gruppen | translationPipe}}
        </dba-settings-item>
        <dba-settings-item icon="groups" routerLink="/master-data-types">Stammdaten</dba-settings-item>
        <dba-settings-item icon="groups" routerLink="/forms">Formulare</dba-settings-item>
        <dba-settings-item icon="qr_code" routerLink="/uuids">Electronic IDs</dba-settings-item>
        }
    </mat-expansion-panel>
</mat-accordion>